__turbopack_context__.v({
  "policiesAnchor": "styles-module-scss-module__jDtpza__policiesAnchor",
  "policiesBlock": "styles-module-scss-module__jDtpza__policiesBlock",
});
